export const LOGIN_URL = process.env.REACT_APP_LOGIN_URL || 'https://adbridge.hnj.io/v1/users/login'
export const LOGIN_SECRET_KEY = process.env.REACT_APP_LOGIN_SECRET_KEY || ';QWyAzo=`q&v]83+e73CZF*A1^5hTN%g'
export const ST_BACKEND_URL = process.env.REACT_APP_ST_BACKEND_URL || "http://localhost:4000";
export const PROD_BACKEND_URL = process.env.REACT_APP_PROD_BACKEND_URL || "http://localhost:3003";
export const BUILD_ID = process.env.REACT_APP_BUILD_ID || "local";
export const APM_ENV = process.env.REACT_APP_APM_ENV || "development";
export const APM_SERVER = process.env.REACT_APP_APM_SERVER || "http://localhost:9999";
export const APM_ACTIVE = process.env.REACT_APP_APM_ACTIVE && process.env.REACT_APP_APM_ACTIVE.toUpperCase() === "TRUE";
